import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { EuiFormRow } from '@elastic/eui'

import { LocationTargetingType, LocationTargetingTypeToLocationType } from '../../../../../api/interfaces/CampaignTargeting'
import { useUpdateCampaignLocationTargetingMutation } from '../../../../../api/rtkQueryApi/platform/campaignsApi'
import { showSuccessToast } from '../../../../../app/appSlice'
import { RootState } from '../../../../../app/rootReducer'
import { LocationTargetingForm } from '../../../../../components/targeting/TargetingForm/LocationTargetingForm'
import { GetLocationTargeting } from '../../../../../utils/CampaignFormatter'
import { fetchCampaign } from '../../campaignSlice'
import { useCampaignEdit } from '../CampaignEditContext'

export const EditBillboardLocationTargeting = () => {
  const { campaign } = useSelector((state: RootState) => state.campaign)
  const { currentAccount } = useSelector((state: RootState) => state.app)
  const [locationTargeting, setLocationTargeting] = useState(GetLocationTargeting(campaign ?? undefined))
  const [updateTargeting, updateTargetingRequest] = useUpdateCampaignLocationTargetingMutation()
  const dispatch = useDispatch()
  const { registerSave, markDirty } = useCampaignEdit()

  useEffect(() => {
    setLocationTargeting(GetLocationTargeting(campaign ?? undefined))
  }, [campaign])

  const onSave = useCallback(async () => {
    if (!campaign || !currentAccount) {
      return
    }
    updateTargeting({
      campaignId: campaign.id,
      accountId: currentAccount?.id,
      targeting: {
        locations: {
          countries: [],
          regions: locationTargeting.targetingType === LocationTargetingType.Region ? locationTargeting.regions ?? [] : [],
          dmas: locationTargeting.targetingType === LocationTargetingType.DMA ? locationTargeting.dmas ?? [] : [],
          cities: locationTargeting.targetingType === LocationTargetingType.City ? locationTargeting.cities ?? [] : [],
          postalCodes: locationTargeting.targetingType === LocationTargetingType.Zip ? locationTargeting.zips ?? [] : [],
          uploadedAudienceUrl: locationTargeting.uploadedAudienceUrl
        },
        geoCircles: locationTargeting.targetingType === LocationTargetingType.Map ? locationTargeting.geoCircles ?? [] : [],
        geoRectangles: locationTargeting.targetingType === LocationTargetingType.Map ? locationTargeting.geoRectangles ?? [] : [],
        geoPolygons: locationTargeting.targetingType === LocationTargetingType.Map ? locationTargeting.geoPolygons ?? [] : [],
        geoFences:
          locationTargeting.targetingType === LocationTargetingType.Address
            ? (locationTargeting.geoFences ?? []).map(f => ({
                placeId: f.placeId,
                radiusUnits: f.radiusUnits,
                radius: f.radius,
                formattedAddress: f.formattedAddress,
                name: f.formattedAddress,
                lat: f.lat,
                lng: f.lng
              }))
            : []
      },
      locationType: LocationTargetingTypeToLocationType(locationTargeting.targetingType),
      audience: {
        ageRanges: [],
        genders: [],
        householdIncomes: [],
        thirdPartyAudiences: [],
        segments: []
      }
    }).then(() => {
      dispatch(showSuccessToast('Saved targeting information'))
      dispatch(fetchCampaign(currentAccount.id, campaign.id))
    })
  }, [campaign, currentAccount, locationTargeting, updateTargeting, dispatch])

  useEffect(() => {
    registerSave('geoTargeting', onSave)
  }, [onSave, registerSave])

  return (
    <>
      <EuiFormRow label={'Choose Location Targeting Strategy'} fullWidth>
        <LocationTargetingForm
          targetingDetails={locationTargeting}
          setTargetingDetails={details => {
            setLocationTargeting(details)
            markDirty('geoTargeting')
          }}
          useDefault
          showBillboardMap={true}
        />
      </EuiFormRow>
    </>
  )
}
